package pogolitics.model

data class Attack(val type: PokemonType, val name: String, val elite: Boolean)